import { jsx as _jsx } from "react/jsx-runtime";
import SeeMoreSidebarBlock from '@hellodarwin/core/lib/components/common/layout/sidebar-page-layout/see-more-sidebar-block';
import SidebarEmpty from '@hellodarwin/core/lib/components/common/layout/sidebar-page-layout/sidebar-empty';
import Loading from '@hellodarwin/core/lib/components/loading';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Email from '@hellodarwin/icons/dist/icons/Email';
import Phone from '@hellodarwin/icons/dist/icons/Phone';
import CardLayout from './card-layout';
const ApplicationAdminCard = ({ isLoading = false, programAdmins, disabledClick = false, }) => {
    const { t } = useTranslations();
    const roleLabels = {
        AccountManager: 'account_manager',
        Analyst: 'analyst',
        Expert: 'expert',
        NoRole: 'no_role',
    };
    const orderAdmins = () => {
        if (programAdmins) {
            const dAdmins = [...programAdmins].sort((a, b) => {
                const roleOrder = Object.keys(roleLabels);
                return (roleOrder.indexOf(a.role || 'NoRole') -
                    roleOrder.indexOf(b.role || 'NoRole'));
            });
            return dAdmins;
        }
        return [];
    };
    const sortedAdmins = orderAdmins();
    if (isLoading)
        return _jsx(Loading, {});
    if (!programAdmins || programAdmins.length === 0)
        return (_jsx(SidebarEmpty, { label: t('application_single|no_application_admins') }));
    return (_jsx(SeeMoreSidebarBlock, { items: sortedAdmins, isLoading: isLoading, title: t('application_single|application_admin'), render: (admin) => (_jsx(CardLayout, { to: disabledClick ? undefined : `/settings/${admin.admin_id}`, title: admin.first_name + ' ' + admin.last_name, subtitle: t(`gin_steps|owner_${roleLabels[admin.role || 'NoRole']}`), infos: [
                { Icon: Phone, value: admin.phone },
                {
                    Icon: Email,
                    value: _jsx("a", { href: 'mailto:' + admin.email, children: admin.email }),
                },
            ] }, admin.admin_id)) }));
};
export default ApplicationAdminCard;
